import { useTranslation } from "react-i18next";
import { Apple, Play } from "lucide-react";
import { AUTHENTICATOR_APP_LINKS } from "../../../lib/authenticatorApps";

/** "Get the app" — App Store + Google Play buttons for an authenticator app. */
export function AppStoreLinks() {
  const { t } = useTranslation();
  return (
    <span className="mfa-stores" data-testid="mfa-store-links">
      <a className="mfa-store" href={AUTHENTICATOR_APP_LINKS.ios} target="_blank" rel="noopener noreferrer">
        <Apple aria-hidden="true" />
        {t("onboarding.kit.mfa.appStore", "App Store")}
      </a>
      <a className="mfa-store" href={AUTHENTICATOR_APP_LINKS.android} target="_blank" rel="noopener noreferrer">
        <Play aria-hidden="true" />
        {t("onboarding.kit.mfa.googlePlay", "Google Play")}
      </a>
    </span>
  );
}
